import { getAverageRating, getTotalReviews } from '@data/companyRatings';

type StarRatingProps = {
	companyName: string;
	showCount?: boolean;
	size?: 'sm' | 'md' | 'lg';
	className?: string;
};

export default function StarRating({ 
	companyName, 
	showCount = true, 
	size = 'md',
	className = '' 
}: StarRatingProps) {
	const rating = getAverageRating(companyName);
	const reviewCount = getTotalReviews(companyName);

	const fullStars = Math.floor(rating);
	const hasHalfStar = rating % 1 >= 0.5;
	const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

	const sizeClass = size === 'sm' ? 'fs-6' : size === 'lg' ? 'fs-4' : 'fs-5';

	return (
		<div className={`d-flex align-items-center gap-1 ${className}`}>
			<div className={`d-flex align-items-center ${sizeClass}`} style={{ color: '#ffc107' }}>
				{Array.from({ length: fullStars }).map((_, i) => (
					<i key={`full-${i}`} className="bi bi-star-fill"></i>
				))}
				{hasHalfStar && <i className="bi bi-star-half"></i>}
				{Array.from({ length: emptyStars }).map((_, i) => (
					<i key={`empty-${i}`} className="bi bi-star"></i>
				))}
			</div>
			<span className="text-muted small ms-1">
				{rating.toFixed(1)}
				{showCount && reviewCount > 0 && (
					<span className="ms-1">({reviewCount})</span>
				)}
			</span>
		</div>
	);
}

